<template>
	<div class="promotional-search-module">
		<div class="search-header">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				class="header-icon"
			>
				<path
					d="M21.5001 23.25L13.6251 15.375C13.0001 15.875 12.2813 16.2708 11.4688 16.5625C10.6563 16.8542 9.79176 17 8.87509 17C6.60426 17 4.68238 16.2135 3.10947 14.6406C1.53655 13.0677 0.750092 11.1458 0.750092 8.87498C0.750092 6.60415 1.53655 4.68228 3.10947 3.10936C4.68238 1.53644 6.60426 0.749985 8.87509 0.749985C11.1459 0.749985 13.0678 1.53644 14.6407 3.10936C16.2136 4.68228 17.0001 6.60415 17.0001 8.87498C17.0001 9.79165 16.8543 10.6562 16.5626 11.4687C16.2709 12.2812 15.8751 13 15.3751 13.625L23.2501 21.5L21.5001 23.25ZM8.87509 14.5C10.4376 14.5 11.7657 13.9531 12.8595 12.8594C13.9532 11.7656 14.5001 10.4375 14.5001 8.87498C14.5001 7.31248 13.9532 5.98436 12.8595 4.89061C11.7657 3.79686 10.4376 3.24998 8.87509 3.24998C7.31259 3.24998 5.98447 3.79686 4.89072 4.89061C3.79697 5.98436 3.25009 7.31248 3.25009 8.87498C3.25009 10.4375 3.79697 11.7656 4.89072 12.8594C5.98447 13.9531 7.31259 14.5 8.87509 14.5Z"
					fill="#7384D8"
				/>
			</svg>
			<span class="search-title">Still Have Questions?</span>
		</div>
		<form
			class="pr-search-wrapper"
			ref="searchFormPr"
			:action="formAction"
			@submit.prevent="doSearchPr"
		>
			<div class="input-wrapper">
				<TypeAhead
					name="query"
					ref="typeaheadPr"
					v-model="searchTermPrm"
					:fetch-suggestions="fetchSearchResultsPr"
					placeholder="Ask Anything..."
					:trigger-on-focus="false"
					:trigger-at-length="3"
					size="medium"
					class="vn-typeahead"
					required
					@select="doSearchPr"
					@keypress.enter.native.prevent="doSearchPr"
					@focus="handleFocusPr"
					v-metric="{ module: 'pstypeahead' }"
				/>

				<button
					type="submit"
					class="search-button"
					@click="handleIconClick"
					v-metric="{ module: 'psmgicon' }"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="19"
						height="19"
						viewBox="0 0 19 19"
						fill="none"
					>
						<path
							d="M16.889 18.25L10.764 12.125C10.2778 12.5139 9.71881 12.8218 9.08687 13.0486C8.45492 13.2755 7.78247 13.3889 7.06951 13.3889C5.3033 13.3889 3.80851 12.7772 2.58513 11.5538C1.36175 10.3304 0.750061 8.83565 0.750061 7.06944C0.750061 5.30324 1.36175 3.80845 2.58513 2.58507C3.80851 1.36169 5.3033 0.75 7.06951 0.75C8.83571 0.75 10.3305 1.36169 11.5539 2.58507C12.7773 3.80845 13.3889 5.30324 13.3889 7.06944C13.3889 7.78241 13.2755 8.45486 13.0487 9.08681C12.8218 9.71875 12.5139 10.2778 12.1251 10.7639L18.2501 16.8889L16.889 18.25ZM7.06951 11.4444C8.28478 11.4444 9.31777 11.0191 10.1685 10.1684C11.0192 9.31771 11.4445 8.28472 11.4445 7.06944C11.4445 5.85417 11.0192 4.82118 10.1685 3.97049C9.31777 3.11979 8.28478 2.69444 7.06951 2.69444C5.85423 2.69444 4.82124 3.11979 3.97055 3.97049C3.11985 4.82118 2.69451 5.85417 2.69451 7.06944C2.69451 8.28472 3.11985 9.31771 3.97055 10.1684C4.82124 11.0191 5.85423 11.4444 7.06951 11.4444Z"
							fill="white"
						/>
					</svg>
				</button>
			</div>
		</form>
		<SearchTags />
	</div>
</template>

<script>
	import { TypeAhead } from 'webmd-elements';
	import SearchTags from './components/SearchTags.vue';
	import useStore from 'webmd-cms-store/src/store';
	import url from 'url';

	export default {
		data() {
			return {
				isMobile: true,
				searchTermPrm: '',
			};
		},

		components: {
			TypeAhead,
			SearchTags,
		},

		props: {},

		created() {
			this.store = useStore(this.$pinia);
		},

		mounted() {
			const self = this;
			this.isMobile = window.matchMedia('(max-width: 1024px)').matches || self.lite;

			// Initialize typeahead suggestions class in mounted hook
			try {
				if (this.$refs.typeaheadPr && this.$refs.typeaheadPr.$refs.suggestions) {
					this.$refs.typeaheadPr.$refs.suggestions.$el.classList.add(
						'ps-typeahead-suggestions'
					);
				}
			} catch (error) {
				// do nothing
			}
		},

		computed: {
			/*
			 * RssData() {
			 *   return this.pageData
			 * },
			 */

			formAction() {
				let canonical = this.store?.pagedata?.meta?.canonicalurl || 'https://www.webmd.com';
				canonical = url.parse(canonical);

				return `https://${canonical.hostname}/search/search_results/default.aspx`;
			},
		},

		methods: {
			// Add watcher method for suggestions
			watchSuggestions() {
				try {
					if (this.$refs.typeaheadPr && this.$refs.typeaheadPr.$refs.suggestions) {
						this.$refs.typeaheadPr.$refs.suggestions.$el.classList.add(
							'ps-typeahead-suggestions'
						);
					}
				} catch (error) {
					// do nothing
				}
			},

			async fetchSearchResultsPr(q, cb) {
				const self = this;
				let resultsPr = [];

				const response = await fetch(
					`https://www.webmd.com/api/qrl/LookupService.ashx?s=2&sz=6&q=${q}`
				);
				const data = await response.json();

				if (data) {
					try {
						resultsPr = data.types[0].references.map((r, i) => ({
							value: r.text,
							index: i + 1,
						}));
					} catch (err) {
						// do nothing
					}
				}

				cb(resultsPr);
				self.$nextTick(() => {
					this.watchSuggestions();
				});
			},

			handleIconClick() {
				if (this.searchTermPrm.trim()) {
					this.doSearchPr();
				} else {
					window.location.href = this.formAction();
				}
			},

			doSearchPr(term) {
				if (term.value) {
					this.$refs.searchFormPr.elements.query.value = term.value;
					this.$vwmdTrack({ moduleName: 'pstypeahead' });
				} else {
					this.$vwmdTrack({ moduleName: 'psmgicon' });
				}

				this.$refs.searchFormPr.submit();
			},

			handleFocusPr() {
				const self = this;

				this.$nextTick(() => {
					if (self.isMobile) {
						self.$refs.typeaheadPr.$refs.suggestions.$el.classList.add(
							'ps-typeahead-suggestions'
						);
					}
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	@import 'stylesheets/searchmodule.scss';
</style>
<style lang="scss">
	@import 'stylesheets/typeahead.scss';
</style>
